var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.252,
    height: 18.508,
    viewBox: "0 0 18.252 18.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18679 20021.068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.608,31.035a.433.433,0,0,0,.4.4h1.714a.433.433,0,0,0,.4-.4V29.627a.217.217,0,0,0-.2-.2H90.709a.217.217,0,0,0-.2.2v1.408Z",
    transform: "translate(-18761.643 -20033.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.373,18.059a3.784,3.784,0,0,0-3.731,3.722v5.532a1.164,1.164,0,0,0,1.21,1.207h5.042a1.164,1.164,0,0,0,1.21-1.207V21.781A3.655,3.655,0,0,0,86.373,18.059Z",
    transform: "translate(-18761.643 -20033.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.062,17.959H94.037a.267.267,0,0,0-.3.3V19.77a.4.4,0,0,1-.807,0V16.249h3.025a.65.65,0,0,0,.6-.6V14.036a.65.65,0,0,0-.6-.6H92.928v-.3a.217.217,0,0,0-.2-.2h-.5a.217.217,0,0,0-.2.2v4.728H90.205a.217.217,0,0,0-.2.2c0,.1,0,.1.1.2a4.727,4.727,0,0,1,1.412,3.319v5.532a2.929,2.929,0,0,1-.2.905c-.1.1,0,.2.1.3h8.37a1.117,1.117,0,0,0,1.109-1.106V21.681A3.871,3.871,0,0,0,97.062,17.959Z",
    transform: "translate(-18761.643 -20033.998)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.aff2a0ff333818f9f17a3856daa38366.svg";
export { ForwardRef as ReactComponent };